var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAhcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 326.56 164.47",
    style: {
      enableBackground: "new 0 0 326.56 164.47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF9E18;}\r\n\t.st1{fill:#FF4D00;}\r\n\t.st2{fill:#76BC21;}\r\n\t.st3{fill:#0099A8;}\r\n\t.st4{fill:#0075A9;}\r\n\t.st5{fill:#00B2E3;}\r\n\t.st6{fill:#231F20;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.35,96.64c0,0.33-0.27,0.6-0.6,0.6h-6.49c-0.33,0-0.6-0.26-0.6-0.6V68.4c0-0.33,0.27-0.6,0.6-0.6h6.49 c0.33,0,0.6,0.27,0.6,0.6V96.64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.89,96.64c0,0.33-0.27,0.6-0.6,0.6h-6.49c-0.33,0-0.6-0.26-0.6-0.6V68.4c0-0.33,0.27-0.6,0.6-0.6h6.49 c0.33,0,0.6,0.27,0.6,0.6V96.64z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.17,96.64c0,0.33-0.27,0.6-0.6,0.6h-6.49c-0.33,0-0.6-0.26-0.6-0.6V55.71c0-0.33,0.27-0.6,0.6-0.6h6.49 c0.33,0,0.6,0.26,0.6,0.6V96.64z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.35,0.8c0-0.33-0.27-0.6-0.6-0.6h-6.49c-0.33,0-0.6,0.27-0.6,0.6v28.24c0,0.33,0.27,0.6,0.6,0.6h6.49 c0.33,0,0.6-0.26,0.6-0.6V0.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.89,0.8c0-0.33-0.27-0.6-0.6-0.6h-6.49c-0.33,0-0.6,0.27-0.6,0.6v28.24c0,0.33,0.27,0.6,0.6,0.6h6.49 c0.33,0,0.6-0.26,0.6-0.6V0.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.52,41.64c0-0.33-0.27-0.6-0.6-0.6h-6.49c-0.33,0-0.6,0.27-0.6,0.6v14.13c0,0.33,0.27,0.6,0.6,0.6h6.49 c0.33,0,0.6-0.27,0.6-0.6V41.64z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.71,41.64c0-0.33-0.27-0.6-0.6-0.6h-6.49c-0.33,0-0.6,0.27-0.6,0.6v14.13c0,0.33,0.27,0.6,0.6,0.6h6.49 c0.33,0,0.6-0.27,0.6-0.6V41.64z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.17,0.8c0-0.33-0.27-0.6-0.6-0.6h-6.49c-0.33,0-0.6,0.27-0.6,0.6v40.93c0,0.33,0.27,0.6,0.6,0.6h6.49 c0.33,0,0.6-0.27,0.6-0.6V0.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.37,31.36c-0.33,0-0.6,0.27-0.6,0.6v6.49c0,0.33,0.27,0.6,0.6,0.6h40.93c0.33,0,0.6-0.27,0.6-0.6v-6.49 c0-0.33-0.27-0.6-0.6-0.6H170.37z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M170.37,58.15c-0.33,0-0.6,0.27-0.6,0.6v6.49c0,0.33,0.27,0.6,0.6,0.6h40.93c0.33,0,0.6-0.27,0.6-0.6v-6.49 c0-0.33-0.27-0.6-0.6-0.6H170.37z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M182.95,44.81c-0.33,0-0.6,0.27-0.6,0.6v6.49c0,0.33,0.27,0.6,0.6,0.6h28.35c0.33,0,0.6-0.26,0.6-0.6v-6.49 c0-0.33-0.27-0.6-0.6-0.6H182.95z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M156.16,44.81c-0.33,0-0.6,0.27-0.6,0.6v6.49c0,0.33,0.26,0.6,0.6,0.6h14.42c0.33,0,0.6-0.26,0.6-0.6v-6.49 c0-0.33-0.26-0.6-0.6-0.6H156.16z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M115.31,44.81c-0.33,0-0.6,0.27-0.6,0.6v6.49c0,0.33,0.26,0.6,0.6,0.6h28.35c0.33,0,0.6-0.26,0.6-0.6v-6.49 c0-0.33-0.27-0.6-0.6-0.6H115.31z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M156.27,31.36c0.33,0,0.6,0.27,0.6,0.6v6.49c0,0.33-0.27,0.6-0.6,0.6h-40.93c-0.33,0-0.6-0.27-0.6-0.6v-6.49 c0-0.33,0.27-0.6,0.6-0.6H156.27z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M156.27,58.15c0.33,0,0.6,0.27,0.6,0.6v6.49c0,0.33-0.27,0.6-0.6,0.6h-40.93c-0.33,0-0.6-0.27-0.6-0.6v-6.49 c0-0.33,0.27-0.6,0.6-0.6H156.27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhcLogo);
export default __webpack_public_path__ + "static/media/ahc-logo.8a4a14f86e9bcad8c126c644131f4728.svg";
export { ForwardRef as ReactComponent };